import { ExportUtils } from '../../common/utils/export';
import { beforeExport } from '../../common/model/constants';
/**
 * `ExportModule` module is used to print and export the rendered chart.
 */
export class Export {
    /**
     * Constructor for export module.
     *
     * @private
     */
    constructor(chart) {
        this.chart = chart;
    }
    /**
     * Handles the export method for chart control.
     */
    export(type, fileName, orientation, controls, width, height, isVertical, header, footer) {
        const exportChart = new ExportUtils(this.chart);
        controls = controls ? controls : [this.chart];
        const argsData = {
            cancel: false, name: beforeExport, width: width, height: height
        };
        this.chart.trigger(beforeExport, argsData);
        if (!argsData.cancel) {
            exportChart.export(type, fileName, orientation, controls, width = argsData.width, height = argsData.height, isVertical, header, footer);
        }
    }
    /**
     * To get data url for charts.
     */
    getDataUrl(chart) {
        const exportUtil = new ExportUtils(chart);
        return exportUtil.getDataUrl(chart);
    }
    /**
     * Get module name.
     */
    getModuleName() {
        // Returns the module name
        return 'Export';
    }
    /**
     * To destroy the chart.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        // Destroy method performed here
    }
}
